export default __webpack_public_path__ + "static/media/error-page-svgrepo-com.faf62317.svg";